import { render, staticRenderFns } from "./BroadcastDate.vue?vue&type=template&id=b25a2cd0&"
import script from "./BroadcastDate.vue?vue&type=script&lang=ts&"
export * from "./BroadcastDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports